import { useEffect, useState, useCallback } from "react";
import { getCompaniesByDomain } from "../services/masterDataService";

export const useCompanies = (domain) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCompanies = useCallback(async () => {
    if (!domain) {
      setCompanies([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getCompaniesByDomain(domain);
      setCompanies(
        data.map((c) => {
          const companyName = (c.companyName || c.sz_company_name || "").trim();
          const aliasName = (c.aliasName || "").trim();
          const baseLabel = c.text || companyName || c.name;

          return {
            value: c.id,
            label: `${baseLabel} - ${c.id}`,
            companyId: c.id,
            companyName,
            aliasName,
          };
        })
      );
    } catch (err) {
      console.error(`Failed to load companies for domain ${domain}:`, err);
      setError(err.message || "Failed to load companies");
      setCompanies([]);
    } finally {
      setLoading(false);
    }
  }, [domain]);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return { companies, loading, error };
};